/**
 * Event design intelligence — occasion-specific colour and mood. The most
 * specific situational source. Keyed by event slug. Additive, pure data.
 */

export const EVENT_KNOWLEDGE = Object.freeze({
  christmas: { asOf: '2026', confidence: 0.58, colorPsychology: ['red-green-and-gold-are-festive'], visualTrends: ['warm-decorative'] },
  ramadan: { asOf: '2026', confidence: 0.58, colorPsychology: ['deep-tones-with-gold-and-crescent-motifs'], visualTrends: ['elegant-ornamental'] },
  diwali: { asOf: '2026', confidence: 0.58, colorPsychology: ['gold-and-vibrant-jewel-tones'], visualTrends: ['radiant-ornamental'] },
  valentines: { asOf: '2026', confidence: 0.58, colorPsychology: ['reds-and-blush-signal-romance'], visualTrends: ['soft-romantic'] },
  'black-friday': { asOf: '2026', confidence: 0.6, colorPsychology: ['high-contrast-black-and-accent'], visualTrends: ['bold-urgent'], ctaBehaviour: ['oversized-offer-cta'] },
  'new-year': { asOf: '2026', confidence: 0.58, colorPsychology: ['black-and-metallic-feel-celebratory'], visualTrends: ['sparkling-elegant'] },
});
